import { initializePaddle, type Paddle, type PaddleEventData } from '@paddle/paddle-js';

// /checkout 是 Paddle 账号的 Default payment link：Paddle 邮件里的付款链接（弃单挽回、更新付款方式等）
// 带着 ?_ptxn=txn_… 打开这里，Paddle.js 初始化后自己打开这笔交易的结账。
// 正式站用 production 和 live_ 开头的 client-side token；测试站可以配 sandbox 的 token。
// token 是公开的，构建时写进页面（Netlify 的环境变量）
export const PADDLE_ENV = process.env.REACT_APP_PADDLE_ENV === 'sandbox' ? 'sandbox' : 'production';
const CLIENT_TOKEN = process.env.REACT_APP_PADDLE_CLIENT_TOKEN || '';

// Paddle.js 每个页面只能初始化一次，结账事件通过 onPaddleEvent 分发给当前页面
type Listener = (event: PaddleEventData) => void;
const listeners = new Set<Listener>();
let paddlePromise: Promise<Paddle | undefined> | null = null;

/** 加载并初始化 Paddle.js；没有配置 token 时返回 undefined */
export function loadPaddle(): Promise<Paddle | undefined> {
  if (!CLIENT_TOKEN) return Promise.resolve(undefined);
  paddlePromise ??= initializePaddle({
    environment: PADDLE_ENV,
    token: CLIENT_TOKEN,
    eventCallback: (event) => listeners.forEach((listener) => listener(event)),
  }).catch((error) => {
    // 脚本没加载出来（比如网络问题）时允许重试
    paddlePromise = null;
    throw error;
  });
  return paddlePromise;
}

/** 订阅结账事件（checkout.loaded / checkout.completed ...），返回取消订阅的函数 */
export function onPaddleEvent(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
